/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions>): BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions(), model);
        BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions>): BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions.newInstance(<BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Master Account ID
     */
    master_account_id: string;

    /**
     * Dimension ID
     */
    dimension_id: string;

    /**
     * Grouping key for the dimension
     */
    grouping_rule_id: string;

}
